// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n/**\n* Colors\n*/\n.Tooltip_tooltipBlock__36UW- {\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 100%;\n  max-width: 100%;\n  padding-right: 10px; }\n", ""]);
// Exports
exports.locals = {
	"tooltipBlock": "Tooltip_tooltipBlock__36UW-"
};
module.exports = exports;
